import { get } from "@/lib/api-client-v2";
import type { GlobalSearchResponse } from "@/types/global-search";

export async function fetchGlobalSearch(
  q: string,
  limit = 6,
): Promise<GlobalSearchResponse> {
  return get<GlobalSearchResponse>("/global-search", { q, limit });
}
